import BaseContainer from "../../Common/BaseContainer";
import LinkGenerator from "../LinkGenerator";
import HelmentComponet from '../../Common/Helmet'
const GenerateUserLink = () => {
 
  return (
    <BaseContainer additionClass={"public-link"} title={'Let’s create your public profile link'}>
      <HelmentComponet title={"Let’s create your public profile link"} />
      <p className={"description BODY_LARGE"}>
           This is the link you can share with your students to start accepting payments. You will not be able to change this link, so choose wisely.
      </p>
      <LinkGenerator />
    </BaseContainer>
  );
}

export default GenerateUserLink;
